export const decodeHtmlEntities = (value) => {
  if (typeof value !== "string" || value.indexOf("&") === -1) {
    return value;
  }

  if (typeof document === "undefined") {
    return value
      .replace(/&#39;/g, "'")
      .replace(/&apos;/g, "'")
      .replace(/&amp;/g, "&")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&quot;/g, '"');
  }

  const textarea = document.createElement("textarea");
  textarea.innerHTML = value;
  return textarea.value;
};

export default decodeHtmlEntities;
